
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { sendPileOperation } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiSiteMonitorPower extends Vue {
  private modalShow = false;
  private title = i18n.t("setPower");
  private itemData: objAny = {};
  private formObj: objAny = {};

  private formInline: objAny = {
    cmdCode: "",
    pilePkId: "",
    gunPkId: "",
    operationType: 3
  };
  private ruleInline: objAny = {
    cmdCode: [{ required: true, message: i18n.t("powerPl"), trigger: "blur" }]
  };

  public open(item: objAny): void {
    this.itemData = item;
    this.modalShow = true;
    this.formInline.pilePkId = item.pilePkId;
    this.formInline.gunPkId = item.gunPkId;
  }

  public handleSubmit(): void {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.subData();
      }
    });
  }
  public handleReset(): void {
    this.formObj.resetFields();
  }
  async subData(): Promise<void> {
    const ret = await sendPileOperation(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("successfullySet"));
      this.modalShow = false;
    }
  }

  mounted(): void {
    this.$nextTick(() => {
      this.formObj = this.$refs.formInline || {};
    });
  }
}
